import { useCallback, useEffect, useState } from "react";
import { IAliasLink, IErrorData } from "@/common/services/types";
import { DEFAULT_ERROR, VERIFIED_ERROR, LinksErrorCodes } from "./constants";
import { ManageLinks } from "components/manage/ManageLinks/ManageLinks";
import { showNotification } from "@/components/notifications/Notifications";
import { apiMain } from "@/common/services";
import { convertException } from "@/common/utils/convertException";
import { useFetch } from "@/common/hooks/useFetch";

interface IManageLinksContainer {
  gifId: string;
}

export const ManageLinksContainer: React.FC<IManageLinksContainer> = ({
  gifId
}) => {
  const [aliasIds, setAliasIds] = useState<IAliasLink[]>([]);

  const fetchAliasLinks = useCallback(() => apiMain.getAliasLinks(gifId), [gifId]);
  const { data, error } = useFetch(fetchAliasLinks);

  useEffect(() => {
    if (!error && data) {
      setAliasIds(data);
    }
  }, [data, error]);

  const handleAddLinkError = (e: IErrorData) => {
    const errorMessage = e?.error?.message || DEFAULT_ERROR;
    const isVerifiedError = e?.error?.code === LinksErrorCodes.AccountNotVerified;

    console.error(errorMessage);

    showNotification({
      title: isVerifiedError ? VERIFIED_ERROR : errorMessage,
      variant: "error"
    });
  };

  const onAddLink = async () => {
    try {
      const link = await apiMain.addAliasLink(gifId);
      setAliasIds(prev => [...prev, link]);
    } catch (err) {
      const e = convertException(err);
      handleAddLinkError(e);
    }
  };

  return (
    <ManageLinks onAddLink={onAddLink} aliasIds={aliasIds} />
  );
};
